import React from "react";
import {
  Grid,
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
  Divider,
  TextField,
  Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { hasDecimalNumbers } from "../../../util/GeneralUtil";

function totalAmountCalculation(quantity, price) {
  return parseFloat(quantity || 0) * parseFloat(price || 0);
}

const SubCategory = ({
  competitionEvent,
  competitionEventCategories,
  handleCategoryChange,
}) => {
  if (!competitionEventCategories || competitionEventCategories.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      {competitionEventCategories.map((category) => (
        <FormControlLabel
          key={category.competitionEventCategoryId}
          onChange={() => handleCategoryChange(competitionEvent, category)}
          checked={
            competitionEvent.selectedCategory?.competitionEventCategoryId ===
            category.competitionEventCategoryId
          }
          control={
            <Checkbox
              color="primary"
              style={{
                color: "#0073e4",
              }}
              checked={
                competitionEvent.selectedCategory
                  ?.competitionEventCategoryId ===
                category.competitionEventCategoryId
              }
            />
          }
          label={category.name}
        />
      ))}
    </Grid>
  );
};

const CompetitionPaymentsSection = ({
  classes,
  competitionEvents,
  selectedCompetition,
  selectedCompetitionId,
  total,
  onCheckboxChange,
  onOfferedDidnotFillChange,
  handleQunatityInputChange,
  handleAddManualAmount,
  handleCategoryChange,
  uploadedDocuments,
  handleFileUploadClick,
  hiddenFileInput,
  handleChange,
  handleFileRemoveClick,
  handleGoBack,
  onSubmit,
}) => {
  return (
    <>
      {/* summary is rendered in parent; here starts the payment sections */}
      <Grid item xs={12}>
        <Typography className={classes.headerText}>
          I wish to pay the following USHJA competitions fees:
        </Typography>
      </Grid>

      {/* MAIN COMPETITION FEE BLOCK */}
      <Grid item xs={12}>
        <Paper elevation={3} square>
          {competitionEvents.map((competitionEvent) => {
            const hasCategory =
              competitionEvent.competition_event_categories &&
              competitionEvent.competition_event_categories.length > 0;
            const totalAmount = totalAmountCalculation(
              competitionEvent.quantity ? competitionEvent.quantity : 0,
              competitionEvent.selectedCategory?.price || competitionEvent.price
            );
            const YHPAmount = totalAmountCalculation(
              competitionEvent.quantity,
              competitionEvent.price
            );

            if (
              competitionEvent.memberCompetition ||
              competitionEvent.horseCompetition ||
              competitionEvent.otherCompetition
            ) {
              return null;
            }

            return (
              <div key={competitionEvent.name}>
                <Grid container style={{ paddingLeft: 10, paddingRight: 10 }}>
                  <Grid item xs={10}>
                    <Grid container>
                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={competitionEvent.isChecked}
                              onChange={() =>
                                onCheckboxChange(competitionEvent)
                              }
                              style={{ color: "#0073e4" }}
                            />
                          }
                          label={
                            <Typography className={classes.headerText}>
                              {competitionEvent.name}
                            </Typography>
                          }
                        />
                      </Grid>

                      {competitionEvent.isChecked && hasCategory && (
                        <SubCategory
                          competitionEvent={competitionEvent}
                          competitionEventCategories={
                            competitionEvent.competition_event_categories
                          }
                          handleCategoryChange={handleCategoryChange}
                        />
                      )}

                      {competitionEvent.additional_title && (
                        <Grid item xs={12}>
                          <Typography
                            style={{
                              paddingLeft: 30,
                              paddingBottom: 5,
                              fontSize: 15,
                            }}
                          >
                            {competitionEvent.additional_title}
                          </Typography>
                        </Grid>
                      )}

                      {competitionEvent.description && (
                        <Grid item xs={12}>
                          <Typography
                            style={{
                              paddingLeft: 30,
                              paddingBottom: 10,
                            }}
                          >
                            {competitionEvent.description}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>

                  {/* amount/quantity side */}
                  {competitionEvent?.isCustomAmount ? (
                    <>
                      <Grid item xs={1}>
                        <TextField
                          className={classes.numberInput}
                          type="number"
                          disabled={
                            !competitionEvent.isChecked ||
                            (hasCategory &&
                              !competitionEvent.selectedCategory
                                ?.competitionEventCategoryId) ||
                            competitionEvent.disableQuantityInput
                          }
                          value={
                            competitionEvent.isChecked && competitionEvent.price
                          }
                          onChange={(e) =>
                            handleAddManualAmount(
                              competitionEvent,
                              e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{ textAlign: "center", paddingTop: 25 }}
                      >
                        <Typography>
                          {competitionEvent.isChecked &&
                            "$" +
                              (hasDecimalNumbers(YHPAmount)
                                ? YHPAmount.toFixed(2)
                                : YHPAmount)}
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={1}>
                        <TextField
                          className={classes.numberInput}
                          type="number"
                          disabled={
                            !competitionEvent.isChecked ||
                            (hasCategory &&
                              !competitionEvent.selectedCategory
                                ?.competitionEventCategoryId) ||
                            competitionEvent.disableQuantityInput
                          }
                          value={
                            competitionEvent.isChecked &&
                            competitionEvent.quantity
                          }
                          onChange={(e) =>
                            handleQunatityInputChange(
                              competitionEvent,
                              competitionEvent.disableQuantityInput
                                ? 1
                                : e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        className={classes.numberInput}
                        style={{ textAlign: "center", paddingTop: 25 }}
                      >
                        <Typography>
                          {competitionEvent.isChecked &&
                            "$" +
                              (hasDecimalNumbers(totalAmount)
                                ? totalAmount.toFixed(2)
                                : totalAmount)}
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
                <Divider
                  style={{
                    marginLeft: 30,
                    marginRight: 30,
                  }}
                />
              </div>
            );
          })}
        </Paper>
      </Grid>

      {/* OUTREACH / OTHER SECTIONS – only for comps other than id 3 */}
      {selectedCompetitionId !== 3 && (
        <>
          {/* USHJA Outreach Fees */}
          {competitionEvents.filter((s) => s.otherCompetition && s.orderId > 0)
            .length > 0 && (
            <Grid item xs={12}>
              <Typography className={classes.headerText}>
                USHJA Outreach Fees
              </Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            {competitionEvents
              .filter((s) => s.otherCompetition && s.orderId > 0)
              .map((competitionEvent) => {
                const hasCategory =
                  competitionEvent.competition_event_categories &&
                  competitionEvent.competition_event_categories.length > 0;
                const totalAmount = totalAmountCalculation(
                  competitionEvent.quantity ? competitionEvent.quantity : 0,
                  competitionEvent.selectedCategory?.price ||
                    competitionEvent.price
                );
                const YHPAmount = totalAmountCalculation(
                  competitionEvent.quantity,
                  competitionEvent.price
                );
                return (
                  <Paper elevation={3} square key={competitionEvent.name}>
                    <div>
                      <Grid
                        container
                        style={{ paddingLeft: 10, paddingRight: 10 }}
                      >
                        <Grid item xs={10}>
                          <Grid container>
                            <Grid item xs={12} md={6}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={competitionEvent.isChecked}
                                    onChange={() =>
                                      onCheckboxChange(competitionEvent)
                                    }
                                    style={{ color: "#0073e4" }}
                                  />
                                }
                                label={
                                  <Typography className={classes.headerText}>
                                    {competitionEvent.name}
                                  </Typography>
                                }
                              />
                            </Grid>

                            {competitionEvent.isChecked && hasCategory && (
                              <SubCategory
                                competitionEvent={competitionEvent}
                                competitionEventCategories={
                                  competitionEvent.competition_event_categories
                                }
                                handleCategoryChange={handleCategoryChange}
                              />
                            )}

                            {competitionEvent.additional_title && (
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    paddingLeft: 30,
                                    paddingBottom: 5,
                                    fontSize: 15,
                                  }}
                                >
                                  {competitionEvent.additional_title}
                                </Typography>
                              </Grid>
                            )}

                            {competitionEvent.description && (
                              <Grid item xs={12}>
                                <Typography
                                  style={{ paddingLeft: 30, paddingBottom: 10 }}
                                >
                                  {competitionEvent.description}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>

                        {competitionEvent?.isCustomAmount ? (
                          <>
                            <Grid item xs={1}>
                              <TextField
                                className={classes.numberInput}
                                type="number"
                                disabled={
                                  !competitionEvent.isChecked ||
                                  (hasCategory &&
                                    !competitionEvent.selectedCategory
                                      ?.competitionEventCategoryId) ||
                                  competitionEvent.disableQuantityInput
                                }
                                value={
                                  competitionEvent.isChecked &&
                                  competitionEvent.price
                                }
                                onChange={(e) =>
                                  handleAddManualAmount(
                                    competitionEvent,
                                    e.target.value
                                  )
                                }
                              />
                            </Grid>
                            <Grid
                              item
                              xs={1}
                              style={{ textAlign: "center", paddingTop: 25 }}
                            >
                              <Typography>
                                {competitionEvent.isChecked &&
                                  "$" +
                                    (hasDecimalNumbers(YHPAmount)
                                      ? YHPAmount.toFixed(2)
                                      : YHPAmount)}
                              </Typography>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid item xs={1}>
                              <TextField
                                className={classes.numberInput}
                                type="number"
                                disabled={
                                  !competitionEvent.isChecked ||
                                  (hasCategory &&
                                    !competitionEvent.selectedCategory
                                      ?.competitionEventCategoryId) ||
                                  competitionEvent.disableQuantityInput
                                }
                                value={
                                  competitionEvent.isChecked &&
                                  competitionEvent.quantity
                                }
                                onChange={(e) =>
                                  handleQunatityInputChange(
                                    competitionEvent,
                                    competitionEvent.disableQuantityInput
                                      ? 1
                                      : e.target.value
                                  )
                                }
                              />
                            </Grid>
                            <Grid
                              item
                              xs={1}
                              style={{
                                textAlign: "center",
                                paddingTop: 25,
                                paddingBottom: 25,
                              }}
                            >
                              <Typography>
                                {competitionEvent.isChecked &&
                                  "$" +
                                    (hasDecimalNumbers(totalAmount)
                                      ? totalAmount.toFixed(2)
                                      : totalAmount)}
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </Grid>
                      <Divider style={{ marginLeft: 30, marginRight: 30 }} />
                    </div>
                  </Paper>
                );
              })}
          </Grid>

          {/* “Please remit…” block */}
          {competitionEvents
            .filter((s) => s.otherCompetition && s.orderId == null)
            .map((competitionEvent) => {
              const totalAmount = totalAmountCalculation(
                competitionEvent.quantity ? competitionEvent.quantity : 0,
                competitionEvent.selectedCategory?.price ||
                  competitionEvent.price
              );

              return (
                <React.Fragment key={competitionEvent.name}>
                  <Grid item xs={12} />
                  <Grid item xs={12}>
                    <Typography className={classes.headerText}>
                      Please Remit to USHJA!
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.headerDataText}>
                      Show Pass Fees, USHJA Memberships, and USHJA Horse
                      Registrations:
                    </Typography>
                    <Typography className={classes.headerDataText}>
                      (Please complete this section if you are including the
                      application payments in your post comp payment. If you
                      complete this section, please upload all membership
                      applications and horse registrations below.)
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper elevation={3} square>
                      <div>
                        <Grid
                          container
                          style={{ paddingLeft: 10, paddingRight: 10 }}
                        >
                          <Grid item xs={10}>
                            <Grid container>
                              <Grid item xs={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      color="primary"
                                      checked={competitionEvent.isChecked}
                                      onChange={() =>
                                        onCheckboxChange(competitionEvent)
                                      }
                                      style={{ color: "#0073e4" }}
                                    />
                                  }
                                  label={
                                    <Typography className={classes.headerText}>
                                      {competitionEvent.name}
                                    </Typography>
                                  }
                                />
                              </Grid>
                              {competitionEvent.description && (
                                <Grid item xs={12}>
                                  <Typography
                                    style={{
                                      paddingLeft: 30,
                                      paddingBottom: "1%",
                                    }}
                                  >
                                    {competitionEvent.description}
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                          <Grid item xs={1}>
                            <TextField
                              className={classes.numberInput}
                              type="number"
                              disabled={
                                !competitionEvent.isChecked ||
                                competitionEvent.disableQuantityInput
                              }
                              value={
                                competitionEvent.isChecked &&
                                competitionEvent.quantity
                              }
                              onChange={(e) =>
                                handleQunatityInputChange(
                                  competitionEvent,
                                  competitionEvent.disableQuantityInput
                                    ? 1
                                    : e.target.value
                                )
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={1}
                            style={{ textAlign: "center", paddingTop: 25 }}
                          >
                            <Typography>
                              {competitionEvent.isChecked &&
                                "$" +
                                  (hasDecimalNumbers(totalAmount)
                                    ? totalAmount.toFixed(2)
                                    : totalAmount)}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Divider style={{ marginLeft: 30, marginRight: 30 }} />
                      </div>
                    </Paper>
                  </Grid>
                </React.Fragment>
              );
            })}

          {/* Membership (included) */}
          <Grid item xs={12} />
          <Grid item xs={12}>
            <Typography className={classes.headerText}>
              USHJA Membership (Included in Payment)
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3} square>
              {competitionEvents.map((competitionEvent) => {
                if (!competitionEvent.memberCompetition) return null;
                const totalAmount = totalAmountCalculation(
                  competitionEvent.quantity ? competitionEvent.quantity : 0,
                  competitionEvent.price
                );
                return (
                  <div key={competitionEvent.name}>
                    <Grid
                      container
                      style={{ paddingLeft: 10, paddingRight: 10 }}
                    >
                      <Grid item xs={10}>
                        <Grid container>
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={competitionEvent.isChecked}
                                  onChange={() =>
                                    onCheckboxChange(competitionEvent)
                                  }
                                  style={{ color: "#0073e4" }}
                                />
                              }
                              label={
                                <Typography className={classes.headerText}>
                                  {competitionEvent.name}
                                </Typography>
                              }
                            />
                          </Grid>
                          {competitionEvent.description && (
                            <Grid item xs={12}>
                              <Typography
                                style={{
                                  paddingLeft: 30,
                                  paddingBottom: "1%",
                                }}
                              >
                                {competitionEvent.description}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs={1}>
                        <TextField
                          className={classes.numberInput}
                          type="number"
                          disabled={
                            !competitionEvent.isChecked ||
                            competitionEvent.disableQuantityInput
                          }
                          value={
                            competitionEvent.isChecked &&
                            competitionEvent.quantity
                          }
                          onChange={(e) =>
                            handleQunatityInputChange(
                              competitionEvent,
                              competitionEvent.disableQuantityInput
                                ? 1
                                : e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{ textAlign: "center", paddingTop: 25 }}
                      >
                        <Typography>
                          {competitionEvent.isChecked &&
                            "$" +
                              (hasDecimalNumbers(totalAmount)
                                ? totalAmount.toFixed(2)
                                : totalAmount)}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider style={{ marginLeft: 30, marginRight: 30 }} />
                  </div>
                );
              })}
            </Paper>
          </Grid>

          {/* Horse registrations */}
          <Grid item xs={12} />
          <Grid item xs={12}>
            <Typography className={classes.headerText}>
              Horse Registrations (Included in Payment)
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3} square>
              {competitionEvents.map((competitionEvent) => {
                if (!competitionEvent.horseCompetition) return null;
                const totalAmount = totalAmountCalculation(
                  competitionEvent.quantity ? competitionEvent.quantity : 0,
                  competitionEvent.price
                );
                return (
                  <div key={competitionEvent.name}>
                    <Grid
                      container
                      style={{ paddingLeft: 10, paddingRight: 10 }}
                    >
                      <Grid item xs={10}>
                        <Grid container>
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={competitionEvent.isChecked}
                                  onChange={() =>
                                    onCheckboxChange(competitionEvent)
                                  }
                                  style={{ color: "#0073e4" }}
                                />
                              }
                              label={
                                <Typography className={classes.headerText}>
                                  {competitionEvent.name}
                                </Typography>
                              }
                            />
                          </Grid>
                          {competitionEvent.description && (
                            <Grid item xs={12}>
                              <Typography
                                style={{
                                  paddingLeft: 30,
                                  paddingBottom: "1%",
                                }}
                              >
                                {competitionEvent.description}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs={1}>
                        <TextField
                          className={classes.numberInput}
                          type="number"
                          disabled={
                            !competitionEvent.isChecked ||
                            competitionEvent.disableQuantityInput
                          }
                          value={
                            competitionEvent.isChecked &&
                            competitionEvent.quantity
                          }
                          onChange={(e) =>
                            handleQunatityInputChange(
                              competitionEvent,
                              competitionEvent.disableQuantityInput
                                ? 1
                                : e.target.value
                            )
                          }
                        />
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{ textAlign: "center", paddingTop: 25 }}
                      >
                        <Typography>
                          {competitionEvent.isChecked &&
                            "$" +
                              (hasDecimalNumbers(totalAmount)
                                ? totalAmount.toFixed(2)
                                : totalAmount)}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider style={{ marginLeft: 30, marginRight: 30 }} />
                  </div>
                );
              })}
            </Paper>
          </Grid>
        </>
      )}

      {/* TOTAL + UPLOAD + ACTIONS */}
      <Grid item xs={12}>
        <Typography className={classes.headerText}>
          Total: ${hasDecimalNumbers(total) ? total.toFixed(2) : total}
        </Typography>
      </Grid>

      <Grid item container xs={12}>
        <Grid item xs={12}>
          <p className={classes.headerText}>
            Upload Results and/or Declarations :
          </p>
        </Grid>
        <Grid item container xs={12}>
          {uploadedDocuments.map((file, index) => (
            <Grid
              item
              style={{ width: file.fileName.length * 10 }}
              key={index}
              className={classes.pdfName}
            >
              <p>
                {file.fileName}
                <span onClick={() => handleFileRemoveClick(index)}>
                  <CloseIcon
                    style={{
                      color: "#EC5269",
                      cursor: "pointer",
                      padding: "1.5px",
                    }}
                  />
                </span>
              </p>
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12}>
          <label className="select-container" onClick={handleFileUploadClick}>
            Select Your File Here
          </label>

          <input
            type="file"
            ref={hiddenFileInput}
            name="Pdf_Upload"
            multiple
            onChange={handleChange}
            className="upload-file"
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          className={classes.buttonStyle}
          onClick={handleGoBack}
        >
          Go Back
        </Button>

        <Button
          variant="contained"
          color="primary"
          className={classes.buttonStyle}
          onClick={onSubmit}
        >
          Pay
        </Button>
      </Grid>
    </>
  );
};

export default CompetitionPaymentsSection;
